<template>
  <div class="mx-0">
    <div v-if="title || titleTooltip || titleLink" class="d-flex mb-4 mx-0">
      <div class="text-h2">
        {{ title }}
      </div>
      <v-tooltip right z-index="200" class="d-none d-md-block">
        <template #activator="{ on }">
          <v-icon
            v-if="titleTooltip"
            size="24"
            class="flex-grow-0 flex-shrink-1 ml-2 d-none d-md-flex"
            v-on="on"
          >
            $info
          </v-icon>
        </template>
        {{ titleTooltip }}
      </v-tooltip>
      <v-spacer />
      <div v-if="titleLink">
        <span
          class="link d-inline-flex"
          data-cy="carouselHolderLinkSpan"
          @click="titleLinkClick($localePath(titleLink.path))"
        >
          {{ titleLink.text }}
          <v-icon class="rotate-270 primary--text" size="24">$dropSmall</v-icon>
        </span>
      </div>
    </div>
    <UlCarousel
      :viewport-classes="viewportClasses"
      :class="[...carouselClassList]"
      :viewport-bottom-padding="viewportBottomPadding"
      :arrows="arrows"
      :pagination="pagination"
      :fade="fade"
      :align="align"
      :pagination-classes="paginationClasses"
      :circular="circular"
      v-on="carouselEvents"
    >
      <slot />
    </UlCarousel>
  </div>
</template>

<script>
export default {
  name: 'CarouselHolder',
  props: {
    title: {
      type: String,
      default: ''
    },
    titleTooltip: {
      type: String,
      required: false
    },
    titleLink: {
      type: Object,
      required: false
    },
    fade: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Boolean,
      default: false
    },
    paginationClasses: {
      type: Array,
      required: false,
      default: () => []
    },
    arrows: {
      type: Boolean,
      default: true
    },
    align: {
      type: String,
      default: 'prev',
      validator(value) {
        return value === 'prev' || value === 'center';
      }
    },
    viewportClasses: {
      type: Array,
      required: false
    },
    viewportBottomPadding: {
      type: Number,
      required: false
    },
    carouselClassList: {
      type: Array,
      default: () => []
    },
    gtmButtonsDetails: {
      type: Object,
      required: false,
      validator(value) {
        if (value === null || value === undefined) {
          return true;
        }

        const requiredKeys = ['buttonDetail', 'service'];
        return requiredKeys.every(rk => !!value[rk]);
      }
    },
    circular: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      carouselEvents: {
        nextClick: () => this.carouselMove('scroll'),
        prevClick: () => this.carouselMove('scroll'),
        nextSwipe: () => this.carouselMove('swipe'),
        prevSwipe: () => this.carouselMove('swipe')
      }
    };
  },
  methods: {
    carouselMove(type) {
      if (this.gtmButtonsDetails) {
        this.gtmPush({
          event: 'button_click',
          'button.type': type,
          'button.detail': this.gtmButtonsDetails.buttonDetail,
          service: this.gtmButtonsDetails.service
        });
      }
    },
    titleLinkClick(path) {
      if (this.gtmButtonsDetails) {
        this.gtmPush({
          event: 'button_click',
          'button.type': this.titleLink.text,
          'button.detail': this.gtmButtonsDetails.buttonDetail,
          service: this.gtmButtonsDetails.service
        });
      }
      this.$router.push(path);
    }
  }
};
</script>
